import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {InvoicesRoutingModule} from './invoices-routing.module';
import {InvoicesComponent} from './components/invoices/invoices.component';
import {InvoicesService} from './services/invoices.service';

const MODULES = [SharedModule, InvoicesRoutingModule];

const COMPONENTS = [InvoicesComponent];

const SERVICES = [InvoicesService];

@NgModule({
    imports: [...MODULES],
    providers: [...SERVICES],
    declarations: [...COMPONENTS]
})
export class InvoicesModule {
}
